var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pin-bookmark-wrapper" }, [
    _c("div", [
      _vm.bookmarkData && _vm.bookmarkData.isPin
        ? _c("div", { on: { click: _vm.handleTogglePin } }, [
            _c("img", {
              staticClass: "unpin-icon",
              attrs: {
                src: require("@/assets/image/homebase/bookmarks/pin-active.svg"),
                alt: "Unpin bookmark"
              }
            })
          ])
        : _c(
            "div",
            {
              staticClass: "pin-btn pin-btn-wrapper",
              on: {
                mouseover: function($event) {
                  return _vm.setDisplayMsg(
                    "Pin limit reached. Please unpin a bookmark and try again."
                  )
                },
                mouseleave: function($event) {
                  return _vm.setDisplayMsg("")
                },
                click: _vm.handleUnpin
              }
            },
            [
              _c("img", {
                staticClass: "pin-icon",
                class: { "pin-disabled": _vm.pinningDisabled },
                attrs: {
                  src: require("@/assets/image/homebase/bookmarks/pin-inactive.svg"),
                  alt: "Pin bookmark"
                }
              })
            ]
          )
    ]),
    _vm._v(" "),
    _vm.successMsg
      ? _c("div", { staticClass: "success-popup" }, [
          _c("div", { staticClass: "success-popup-card px-2 py-1" }, [
            _vm._v("\n      " + _vm._s(_vm.successMsg) + "\n    ")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.displayMsg && _vm.displayMsg.length > 0
      ? _c("div", { staticClass: "pin-disabled-popup" }, [
          _c("div", { staticClass: "pin-disabled-popup-card px-2 py-1" }, [
            _vm._v("\n      " + _vm._s(_vm.displayMsg) + "\n    ")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8cbfdac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8cbfdac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/bookmarks/PinBookmark.vue
// module id = null
// module chunks = 